module.exports = __webpack_public_path__ + "media/Video 72.10afd4da.mp4";